import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicantSourceOfWealth implements Deserializable {
  public ApplicantNumber?: number;
  public SourceOfWealthID: number;
  public SourceOfWealthCode: string;
  public SourceOfWealthDetails: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
